const TodoList = [
    {
        id:1,
        todo: "Do something special",
        completed:true
    },

    {
        id:2,
        todo: "Do something adventurous",
        completed: false
    },
    {
        id:3,
        todo: "Do something dangerous",
        completed: false
    },
    {
        id:4,
        todo: "Do something daily",
        completed: false
    },
    {
        id:5,
        todo: "Do something interesting",
        completed: false
    },
    {
        id:6,
        todo: "Do something different",
        completed: false
    }
]
export default TodoList;